import { $t } from '@/i18n';
import { isEmpty } from 'lodash';
import { MessagePlugin } from 'tdesign-vue';
export function setupHandleErrorInterceptor(axiosInstance) {
    axiosInstance.interceptors.response.use(undefined, (error) => {
        if (!error.response || error.response.status !== 403) {
            return Promise.reject(error);
        }
        const projectId = extractProjectIdFromUrl(error.config.url);
        const target = get403Href(projectId, error.response.data.data);
        MessagePlugin.error({
            content: h => h('span', {}, [$t('k_9343d92b'), h('a', { attrs: { href: target, target: '_blank' } }, [$t('k_dfa53415')])]),
            duration: 5000,
            placement: 'top',
        });
        return Promise.reject(error);
    });
}
function extractProjectIdFromUrl(urlPath) {
    const parts = urlPath.split('/datasource/collection/request/');
    if (parts.length < 2)
        return '';
    const afterRequest = parts[1].split('/');
    return afterRequest.length > 1 ? afterRequest[0] : '';
}
function get403Href(projectId, data) {
    const { origin, pathname } = location;
    const { pathPrefix } = window.GLOBAL_INFO;
    const p403Info = getPage403Info();
    const p403 = p403Info.path || '/403';
    const search = isEmpty(data) ? '' : String(new URLSearchParams(data));
    const query403 = p403Info.path ? p403Info.query?.replace(/^\?/, '') ?? '' : '';
    const searchPart = [query403, search].filter(Boolean).join('&');
    let path = p403;
    if (pathname.startsWith(`${pathPrefix}/xy/app/`)) {
        const [prefix] = pathname.split(`/${projectId}/`);
        path = `${prefix}/${projectId}${p403}`;
    }
    else if (pathname.startsWith('/page/')) {
        path = `/page${p403}`;
    }
    const result = `${origin}${path}${searchPart ? `?${searchPart}` : ''}`;
    return result;
}
;
function getPage403Info() {
    const { page403 = '' } = window.xy_runtime_project;
    let p403Info = { path: '', query: '' };
    if (page403?.startsWith('{')) {
        try {
            p403Info = JSON.parse(page403);
        }
        catch (error) {
            // ignore
        }
    }
    else if (page403?.startsWith('/')) {
        p403Info = { path: page403, query: '' };
    }
    return p403Info;
}
;
